import dynamicfunction from '../utils/dynamicfunction';
import { cn } from '../utils/utils';

const ViewItems = ({ children, className, style, onClick }) => {
  const { isArabic } = dynamicfunction();

  return <div className={cn('flex flex-col', isArabic ? 'items-end' : 'items-start', className)} onClick={onClick} style={style}>{children}</div>;
};

export default ViewItems;
